import { useTranslations } from "next-intl";
import ErrorBox from "./errorBox";
import CredError from "./credError";
import SelectAdminAccount from "@/components/form/selectAdminAccount";


export default function MultiError({code, message}:{code?: string; message?: string}){

    console.log(`Error code: ${code} message: ${message}`)
    if(message){
        return(
            <ErrorBox>{message}</ErrorBox>
        )
    }

    const t = useTranslations("error");

    if(!code){
        return (<ErrorBox>{t("serverError")}</ErrorBox>)
    }

    if(code == "unauthorized"){
        return(
            <CredError></CredError>
        )
    }

    if(code.startsWith("error.")){
        code=code.replace("error.", "")
    }

    return (
        <ErrorBox>{t(code)}</ErrorBox>
    )

}